
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 455.29 455.34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M0 227.5C.23 98.6 106.48-2.7 232.72.06c120.67 2.63 222.47 100.87 222.57 227.53.11 129-106.46 231.09-233.91 227.67C101 452 .15 353.65 0 227.5zm237.64 90.37c1.05.11 1.85.28 2.65.28 20.33 0 40.67.49 61-.13 24.15-.74 45.07-10 62-27.25 42.3-43 33.06-124.78-35.66-150-12.07-4.43-24.54-5.13-37.2-4.12v32.21c5.55 0 10.73-.42 15.82.07 21.72 2.09 42.35 20.33 48.19 42.28 6.35 23.84-2.3 48.93-21.07 62.9-19.32 14.38-41.38 12-63.74 11.68V93.3h-32zm-72.84-31.7h-9c-24.74-.06-48-17.55-54.81-41.19-7.39-25.74 2.26-52.37 23.49-66.36 18.82-12.4 39.69-9.75 61.09-9.81v192.52h31.82V136.67h-62.12a80.16 80.16 0 00-11 .71c-36.93 5.19-66.6 31.81-75.29 67.44-9.13 37.45 4.32 74.78 34.93 96.8 18.15 13.05 38.28 18.7 60.82 16.06z","fill":"#329d28","data-name":"Layer 1"}})])])
          )
        }
      }
    